"use client";

import { cn, Table } from "@kyan/ui";
import type { FC } from "react";

import { columns, createGreeksData } from "./GreeksTable.config";

export interface GreeksTableProps {
  delta?: number;
  gamma?: number;
  vega?: number;
  theta?: number;
  variant?: "standalone" | "embedded";
}

export const GreeksTable: FC<GreeksTableProps> = ({
  variant = "standalone",
  ...greeks
}) => {
  const data = createGreeksData(greeks);
  const isStandalone = variant === "standalone";

  return (
    <Table
      hideHeader
      data={data}
      columns={columns}
      minCellWidth="32px"
      classes={{
        wrapper: "group",
        table: cn("border-divider border", {
          "rounded-sm": isStandalone,
          "group-second:rounded-r-sm group-first:rounded-l-sm group-first:border-r-0":
            !isStandalone,
        }),
        row: "h-8 first:border-t-0",
        cellClassName: ({ cellIndex, rowIndex }) => {
          const isFirstCell = cellIndex === 0;
          const isFirstRow = rowIndex === 0;
          const isLastRow = rowIndex === data.length - 1;

          return cn("p-0", {
            "border-divider border-r": cellIndex < 2,
            "text-textPrimary px-2": cellIndex > 0,
            [isStandalone ? "rounded-tl-sm" : "group-first:rounded-tl-sm"]:
              isFirstCell && isFirstRow,
            [isStandalone ? "rounded-bl-sm" : "group-first:rounded-bl-sm"]:
              isFirstCell && isLastRow,
          });
        },
      }}
    />
  );
};
